import $api from "@/core/services/ApiService";
import { AxiosResponse } from "axios";

class ExchangeEndpoint {
  public rates(
    fromCurrency: string,
    toCurrency: string
  ): Promise<AxiosResponse> {
    return $api.get(`rates/${fromCurrency}/${toCurrency}`);
  }
}

export default ExchangeEndpoint;
